export enum Target {
	Collection = 'Collection',
	Creations = 'Creations',
	Gallery = 'Gallery',
	UserGallery = 'UserGallery',
}
